let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iW8Tl")).then(() => parcelRequire('hLNj0'));